import { useEffect, useRef } from 'react';

const AUTO_LOGOUT_MINUTES = 60;
const INACTIVITY_TIME = AUTO_LOGOUT_MINUTES * 60 * 1000; // 60 minutes

export function useAutoLogout(logoutFn: () => void): void {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = (): void => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      logoutFn();
    }, INACTIVITY_TIME);
  };

  useEffect((): (() => void) => {
    const activityEvents: string[] = [
      'mousedown',
      'mousemove',
      'keydown',
      'scroll',
      'touchstart',
    ];

    activityEvents.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return (): void => {
      if (timerRef.current) clearTimeout(timerRef.current);
      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, []);
}
